import type { ResponseWithType } from './types';
import type {
  FinisherCertificateRest,
  FinisherCertificateWithTypename,
} from './types/finisher-certificate.ts';

const finisherCertificate = ({
  data,
}: ResponseWithType<FinisherCertificateRest>): FinisherCertificateWithTypename => ({
  ...data,
  __typename: 'FinisherCertificate',
});

export default finisherCertificate;
